export class UsersPagination {
  constructor(
    public page: number,
    public next?: string,
    public previous?: string
  ) {}
}
